'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const debounceOptions={
maxWait:3000,
trailing:!0};


const _ExpiredCookieCheckFrequencyMs=10000;let

CookieRefresherService=class CookieRefresherService extends BaseService{
constructor($http,errorHandlers){
super();
this._$http=$http;
this._errorHandlers=errorHandlers;
this.refreshCookie=_.debounce(this.refreshCookieImmediate.bind(this),1500,debounceOptions);

setInterval(async()=>{
if(_.exists(errorHandlers.currentUser)){
const res=await this.refreshCookieImmediate();
if(res==='unauthorized'){
if(this.socketService){
this.socketService.reconnect();
}
errorHandlers.onSessionExpired();
}
}
},_ExpiredCookieCheckFrequencyMs);
}

async refreshCookieImmediate(){
try{
await this._$http({
method:'GET',
url:`/cookieRefresher`});

return'ok';
}catch(err){
if(_.get(err,'status')===401){
return'unauthorized';
}else{
console.error(err);

return'errored';
}
}
}};


module.exports=CookieRefresherService;
//# sourceMappingURL=cookieRefresherService.js.map
